export const EEnvironment = {
  DEVELOPMENT: 'development',
  RELEASE: 'release',
  PRODUCTION: 'production',
} as const;

export type TEnvironment = (typeof EEnvironment)[keyof typeof EEnvironment];
